import moment from "moment";

export const numberFormat = (num, dotNum = 2) => {
    const beauty = str => str.replace(/(\.0+$)|(\.\d0)$/, (match, p1, p2) => {
        if (p1 !== undefined) { return '' }
        if (p2 !== undefined) { return p2.slice(0, -1) }
        return match
    })
    if (Math.abs(num) >= 100000000) {
        return `${beauty((num / 100000000).toFixed(dotNum))} 亿`
    } else if (Math.abs(num) >= 10000) {
        return `${beauty((num / 10000).toFixed(dotNum))} 万`
    }
    return num
}

export const sort = (datas) => {
    if(typeof(datas[0]) == 'number') {
        return datas.sort(function sequence(a,b){return a - b})
    }
    else {
        return datas.sort()
    }
}

export const format = (value, round) => {
  if(_.isNil(value)) {
      return '/'
  }
  if(!isNaN(value))
      return round?Math.round(value).toLocaleString():value.toLocaleString()
  else
      return value
}

export const weekday = ["一", "二","三", "四","五", "六", "日"]
export const weekday_en = ["Mon.", "Tues.","Wed.", "Thur.","Fri.", "Sat.", "Sun."]
export const monthname = ["一", "二","三", "四","五", "六", "七", "八","九", "十", "十一", "十二"]

// 用于本地调起POPO
export const encrypt = (h) => {
  const a = []
  let e = 0
  for (let g = 0; g < h.length; g += 1) {
    const f = encodeURI(h[g])
    if (f.length === 1) {
      const d = f.charCodeAt(0)
      /* eslint-disable */
      a[2 * e] = ((d & 240) >> 4).toString(16)
      a[2 * e + 1] = (d & 15).toString(16)
      e += 1
    } else {
      const c = f.split('%')
      for (let b = 1; b < c.length; b += 1) {
        const d = parseInt('0x' + c[b])
        /* eslint-disable */
        a[2 * e] = ((d & 240) >> 4).toString(16)
        a[2 * e + 1] = (d & 15).toString(16)
        e += 1
      }
    }
  }
  return a.join('')
}

// 22-12-8: 本期、同比、环比，版本日对齐策略
export const versionDurationDays = (baseDt, days, curDt, versionDays) => {
  if (versionDays && days >= 6) {
    let baseVerNum;
    let curVerNum;
    let nextVerNum;
    const tryDays = Math.max(days, 14);
    for (let i = 0; i < tryDays; i++) {
      if (baseVerNum === void 0 && versionDays[moment(baseDt).add(i, 'day').format('YYYY-MM-DD')] != null) {
        baseVerNum = i;
      }
      // 接下来的两个版本时间
      if (nextVerNum === void 0 && curVerNum !== void 0 && versionDays[moment(curDt).add(i, 'day').format('YYYY-MM-DD')] != null) {
        nextVerNum = i;
      }
      if (curVerNum === void 0 && versionDays[moment(curDt).add(i, 'day').format('YYYY-MM-DD')] != null) {
        curVerNum = i;
      }    
      if (baseVerNum !== void 0 && curVerNum !== void 0 && nextVerNum !== void 0) {
        break;
      }
    }
    
    if (baseVerNum !== void 0 && curVerNum !== void 0) {
      const v1duration = curVerNum - baseVerNum;
      const v2duration = nextVerNum - baseVerNum;
      return Math.abs(v1duration) <= Math.abs(v2duration) ? v1duration : v2duration;
    } else {
      return 0;
    }
    
  } else {
    return 0;
  }
}

export const infoRender = (modInfo, dataInfo, datas) => {
  // 以数据info为优先
  let text = dataInfo && dataInfo.text || modInfo && modInfo.text
  if(!text) {
    return undefined
  } 
  const fields = []
  const _fields = text.match(/{{.*?}}/g)
  if(_fields) {
    _fields.forEach(f=>{
      fields.push(f.substr(2, f.length-4).trim())
    })
  }
  const source = dataInfo && dataInfo.source || dataInfo && dataInfo.datas?dataInfo && dataInfo.source || dataInfo && dataInfo.datas:undefined || modInfo && modInfo.source

  // 从info数据中取
  let data = {}
  if(source==='info') {
    data = dataInfo && dataInfo.datas || {}
  }
  else if(source==='summary') {
    // 从summary数据中取
    data = (datas?datas.find(row=>row['_summary']):{}) || {}
  }
  else {
    data = {}
    if(datas) {
      fields.forEach(field=>{
        let value = 0
        let hasV = false
        datas.forEach(row=>{
          if(row[field]!=null && typeof row[field] === 'number') {
            hasV = true
            value += row[field]
          }
        })
        if(hasV) {
          data[field] = value
        }
      })
    }
  }
  fields.forEach((field, fi)=>{
    const f = _fields[fi]
    text = text.replaceAll(f, numberFormat(data[field]!=null?data[field]:''))
  })
  return text

}